import type { AuthenticationStoreState } from "../types/AuthenticationStoreState";
import { makeUserTrackedPromise } from "./helpers/make-user-tracked-promise";

export const getInitialAuthenticationStoreState =
  (): AuthenticationStoreState => {
    return {
      userTrackedPromise: makeUserTrackedPromise(),
    };
  };
